import useSWR from 'swr';

export interface KPISnapshot {
  snapshot_at: string;
  projects_total: number;
  repositories_total: number;
  repositories_by_kind: Record<string, number>;
  artifacts_total: number;
  downloads_total: number;
  downloads_by_kind: Record<string, number>;
  downloads_30d: number;
  service_accounts_active: number;
  service_accounts_total: number;
  logins_30d: number;
  logins_by_method: Record<string, number>;
  users_active: number;
  users_total: number;
  advisories_total: number;
  blocks_active: number;
}

const fetcher = (url: string) =>
  fetch(url, { credentials: 'include', headers: { Accept: 'application/json' } }).then((r) => {
    if (!r.ok) throw new Error(`${r.status} ${r.statusText}`);
    return r.json();
  });

// KPIs are platform-wide totals; they don't move minute-to-minute.
// Refresh once per 24h (matches the heartbeat interval). The user
// can hard-reload the page if they want fresh numbers right now.
export function useKPIs() {
  return useSWR<KPISnapshot>('/api/admin/kpis', fetcher, {
    refreshInterval: 24 * 60 * 60 * 1000,
    revalidateOnFocus: false,
  });
}
